import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DriverFormPage } from '@/areas/manufacturing-templates/Drivers/DriverCreation/DriverFormPage';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/drivers/create')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <DriverFormPage />;
}
